module.exports = __webpack_public_path__ + "static/media/component-13-1.3528b102.svg";